export default __webpack_public_path__ + "static/media/TH-55JX600 01.b547200c.jpg";